import { isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NoSsrModalGuard implements CanActivate {
  #platformId = inject(PLATFORM_ID);
  #router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    // Если мы на сервере и это модальный маршрут, перенаправляем на тот же URL без outlet
    if (isPlatformServer(this.#platformId) && route.outlet === 'modal') {
      // Получаем текущий URL и удаляем из него часть с модальным окном
      const currentUrl = state.url;
      const baseUrl = currentUrl.replace(/\(modal:[^)]+\)/, '');

      // Перенаправляем на базовый URL без модального окна
      return this.#router.parseUrl(baseUrl);
    }
    return true;
  }
}
